<template>
  <div
    v-if="isBackgroundQuote"
    class="quotation"
    :class="`quotation--${quotePosition}`"
    :style="{
      background: `${gradientStyle}, url(${image}) center / cover no-repeat`,
    }"
    :aria-label="imageDescription"
  >
    <div
      class="quotation__content"
      :class="`quotation__content--${textAlignment}`"
    >
      <span class="quotation__symbol">
        <svg
          v-if="quoteStyle === 'rounded'"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 320 320"
          loading="lazy"
          :width="quoteSize"
          :height="quoteSize"
          :fill="quoteColor"
        >
          <path
            d="M82.87 129.48S77.32 98.96 114.31 74c-12.95 0-89.7 30.52-89.7 113.74 0 33.09 27.59 59.73 61.01 58.19 29.85-1.37 54.07-25.6 55.44-55.45 1.54-33.41-25.1-61-58.19-61zm154.26 0S231.58 98.96 268.57 74c-12.95 0-89.7 30.52-89.7 113.74 0 33.09 27.58 59.73 61.01 58.19 29.85-1.37 54.07-25.6 55.44-55.45 1.54-33.41-25.1-61-58.19-61z"
          />
        </svg>

        <c-icon
          v-else
          name="left-quote"
          size="xl"
          :color="quoteColor"
        />
      </span>
      <blockquote
        class="quotation__text"
        :class="`quotation__text--${quoteTextSize}`"
        :style="{ color: quoteTextColor, fontWeight: quoteTextWeight }"
      >
        <slot name="quote" />
      </blockquote>
      <p
        class="quotation__description"
        :class="[
          `quotation__description--${descriptionSize}`,
          `quotation__description--align-${descriptionAlignment}`,
        ]"
        :style="{
          color: descriptionColor,
        }"
      >
        <slot name="description" />
      </p>
      <p
        class="quotation__author"
        :class="[
          `quotation__author--${authorSize}`,
          `quotation__author--align-${authorAlignment}`,
        ]"
        :style="{ color: authorColor, fontWeight: authorWeight }"
      >
        <slot name="author" />
      </p>
      <span class="quotation__symbol">
        <svg
          v-if="quoteStyle === 'rounded'"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 320 320"
          loading="lazy"
          :width="quoteSize"
          :height="quoteSize"
          :fill="quoteColor"
          class="quotation__symbol--bottom"
        >
          <path
            d="M82.87 129.48S77.32 98.96 114.31 74c-12.95 0-89.7 30.52-89.7 113.74 0 33.09 27.59 59.73 61.01 58.19 29.85-1.37 54.07-25.6 55.44-55.45 1.54-33.41-25.1-61-58.19-61zm154.26 0S231.58 98.96 268.57 74c-12.95 0-89.7 30.52-89.7 113.74 0 33.09 27.58 59.73 61.01 58.19 29.85-1.37 54.07-25.6 55.44-55.45 1.54-33.41-25.1-61-58.19-61z"
          />
        </svg>

        <c-icon
          v-else
          name="right-quote"
          size="xl"
          :color="quoteColor"
        />
      </span>
    </div>
  </div>

  <div
    v-else
    class="quoteWithImage"
    :class="`quoteWithImage--${imageDirection}`"
  >
    <div
      class="quoteWithImage__wrapper"
      :class="`quoteWithImage__wrapper--${quotePosition} `"
    >
      <div
        class="quoteWithImage__content"
        :class="`quoteWithImage__content--${textAlignment}`"
      >
        <span class="quoteWithImage__symbol">
          <svg
            v-if="quoteStyle === 'rounded'"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 320"
            loading="lazy"
            :width="quoteSize"
            :height="quoteSize"
            :fill="quoteColor"
          >
            <path
              d="M82.87 129.48S77.32 98.96 114.31 74c-12.95 0-89.7 30.52-89.7 113.74 0 33.09 27.59 59.73 61.01 58.19 29.85-1.37 54.07-25.6 55.44-55.45 1.54-33.41-25.1-61-58.19-61zm154.26 0S231.58 98.96 268.57 74c-12.95 0-89.7 30.52-89.7 113.74 0 33.09 27.58 59.73 61.01 58.19 29.85-1.37 54.07-25.6 55.44-55.45 1.54-33.41-25.1-61-58.19-61z"
            />
          </svg>

          <c-icon
            v-else
            name="left-quote"
            size="xl"
            :color="quoteColor"
          />
        </span>
        <blockquote
          class="quoteWithImage__text"
          :class="`quoteWithImage__text--${quoteTextSize}`"
          :style="{ color: quoteTextColor, fontWeight: quoteTextWeight }"
        >
          <slot name="quote" />
        </blockquote>
        <p
          class="quoteWithImage__description"
          :class="[
            `quoteWithImage__description--${descriptionSize}`,
            `quoteWithImage__description--align-${descriptionAlignment}`,
          ]"
          :style="{
            color: descriptionColor,
          }"
        >
          <slot name="description" />
        </p>
        <p
          class="quoteWithImage__author"
          :class="[
            `quoteWithImage__author--${authorSize}`,
            `quoteWithImage__author--align-${authorAlignment}`,
          ]"
          :style="{ color: authorColor, fontWeight: authorWeight }"
        >
          <slot name="author" />
        </p>
        <span class="quoteWithImage__symbol">
          <svg
            v-if="quoteStyle === 'rounded'"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 320"
            loading="lazy"
            :width="quoteSize"
            :height="quoteSize"
            :fill="quoteColor"
            class="quoteWithImage__symbol--bottom"
          >
            <path
              d="M82.87 129.48S77.32 98.96 114.31 74c-12.95 0-89.7 30.52-89.7 113.74 0 33.09 27.59 59.73 61.01 58.19 29.85-1.37 54.07-25.6 55.44-55.45 1.54-33.41-25.1-61-58.19-61zm154.26 0S231.58 98.96 268.57 74c-12.95 0-89.7 30.52-89.7 113.74 0 33.09 27.58 59.73 61.01 58.19 29.85-1.37 54.07-25.6 55.44-55.45 1.54-33.41-25.1-61-58.19-61z"
            />
          </svg>

          <c-icon
            v-else
            name="right-quote"
            size="xl"
            :color="quoteColor"
          />
        </span>
      </div>
    </div>
    <img
      class="quoteWithImage__image"
      :src="image"
      :alt="imageDescription"
    >
  </div>
</template>

<script>
import CIcon from '@ions/icon/icon.vue'

export default {
  name: 'smart-quote',
  components: {
    CIcon,
  },
  props: {
    isBackgroundQuote: {
      type: Boolean,
      default: true,
    },
    image: {
      type: String,
    },
    imageDescription: {
      type: String,
      default: '',
    },
    imageDirection: {
      type: String,
      default: 'left',
      validator: (value) => ['left', 'right'].includes(value),
    },
    gradientType: {
      type: String,
      default: 'dark',
      validator: (value) => ['blue', 'dark', 'dark-ocean', 'gray', 'light'].includes(value),
    },
    textAlignment: {
      type: String,
      default: 'left',
      validator: (value) => ['left', 'center', 'right'].includes(value),
    },
    quoteColor: {
      type: String,
      default: '#233037',
    },
    quoteSize: {
      type: Number,
      default: 64,
    },
    quotePosition: {
      type: String,
      default: 'center',
      validator: (value) => ['top', 'center', 'bottom'].includes(value),
    },
    quoteStyle: {
      type: String,
      default: 'rounded',
      validator: (value) => ['rounded', 'square'].includes(value),
    },
    quoteTextSize: {
      type: String,
      default: 'medium',
      validator: (value) => ['small', 'medium', 'large'].includes(value),
    },
    quoteTextColor: {
      type: String,
      default: '#233037',
    },
    quoteTextWeight: {
      type: String,
      default: '400',
    },
    descriptionSize: {
      type: String,
      default: 'medium',
      validator: (value) => ['small', 'medium', 'large'].includes(value),
    },
    descriptionColor: {
      type: String,
      default: '#233037',
    },
    descriptionAlignment: {
      type: String,
      default: 'left',
      validator: (value) => ['left', 'center', 'right'].includes(value),
    },
    authorSize: {
      type: String,
      default: 'medium',
      validator: (value) => ['small', 'medium', 'large'].includes(value),
    },
    authorColor: {
      type: String,
      default: '#233037',
    },
    authorWeight: {
      type: String,
      default: '400',
    },
    authorAlignment: {
      type: String,
      default: 'left',
      validator: (value) => ['left', 'center', 'right'].includes(value),
    }
  },
  computed: {
    gradientStyle() {
      const gradients = {
        blue: 'linear-gradient(135deg, #074E8ECC, #2D3648E6)',
        dark: 'linear-gradient(135deg, #000000CC, #434343CC)',
        'dark-ocean': 'linear-gradient(to right, #373b44CC, #2D3648CC)',
        gray: 'linear-gradient(135deg, #233037CC, #A0ABC0CC)',
        light: 'linear-gradient(135deg, #FFFFFFCC, #D9E2ECE6)',
      }

      return gradients[this.gradientType] || gradients.dark
    },
  },
}
</script>

<style lang="scss" scoped>
.quotation,
.quoteWithImage {
  display: flex;
  width: 100%;
  height: 100vh;
  padding: 8%;

  &--top {
    align-items: flex-start;
  }

  &--center {
    align-items: center;
  }

  &--bottom {
    align-items: flex-end;
  }

  &__content {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 1rem;
  }

  &__symbol {
    opacity: 0.5;
  }

  &__text,
  &__description,
  &__author {
    line-height: 1.75rem;
    @include weight();
  }

  &__text {
    margin-block-start: unset;
    margin-block-end: unset;
    margin-inline-start: unset;
    margin-inline-end: unset;
    overflow-y: scroll;
    scroll-behavior: smooth;
    scrollbar-width: none;

    &--small {
      font-size: 1.25rem;

      @include screen-size('md') {
        font-size: 1.375rem;
      }

      @include screen-size('xl') {
        font-size: 1.5rem;
      }
    }

    &--medium {
      font-size: 1.375rem;

      @include screen-size('md') {
        font-size: 1.5rem;
      }

      @include screen-size('xl') {
        font-size: 1.625rem;
      }
    }

    &--large {
      font-size: 1.5rem;

      @include screen-size('md') {
        font-size: 1.625rem;
      }

      @include screen-size('xl') {
        font-size: 1.75rem;
      }
    }
  }

  &__description {
    @include font-telegraf(400);
    text-decoration: underline;
    text-underline-offset: 0.25rem;

    &--small {
      font-size: 1.125rem;

      @include screen-size('md') {
        font-size: 1.25rem;
      }

      @include screen-size('xl') {
        font-size: 1.375rem;
      }
    }

    &--medium {
      font-size: 1.25rem;

      @include screen-size('md') {
        font-size: 1.375rem;
      }

      @include screen-size('xl') {
        font-size: 1.5rem;
      }
    }

    &--large {
      font-size: 1.375rem;

      @include screen-size('md') {
        font-size: 1.5rem;
      }

      @include screen-size('xl') {
        font-size: 1.625rem;
      }
    }

    &--align-left {
      text-align: left;
    }

    &--align-center {
      text-align: center;
    }

    &--align-right {
      text-align: right;
    }
  }

  &__author {
    &--small {
      font-size: 1rem;

      @include screen-size('md') {
        font-size: 1.125rem;
      }

      @include screen-size('xl') {
        font-size: 1.25rem;
      }
    }

    &--medium {
      font-size: 1.125rem;

      @include screen-size('md') {
        font-size: 1.25rem;
      }

      @include screen-size('xl') {
        font-size: 1.375rem;
      }
    }

    &--large {
      font-size: 1.25rem;

      @include screen-size('md') {
        font-size: 1.375rem;
      }

      @include screen-size('xl') {
        font-size: 1.375rem;
      }
    }

    &--align-left {
      text-align: left;
    }

    &--align-center {
      text-align: center;
    }

    &--align-right {
      text-align: right;
    }
  }
}

.quotation {
  max-height: 40.625rem;

  &__content {
    @include textAlign();
  }
}

.quoteWithImage {
  flex-direction: column;
  justify-content: center;
  gap: 2rem;
  padding: unset;
  height: unset;

  @include screen-size('xl') {
    &--left {
      flex-direction: row-reverse;
    }

    &--right {
      flex-direction: row;
    }
  }

  &__content {
    &--left {
      text-align: left;
    }

    &--center {
      text-align: center;
    }

    &--right {
      text-align: right;
    }
  }

  &__wrapper {
    display: flex;

    &--top {
      align-items: flex-start;
    }

    &--center {
      align-items: center;
    }

    &--bottom {
      align-items: flex-end;
    }
  }

  &__image {
    width: 100%;
    object-fit: contain;

    @include screen-size('xl') {
      width: 40%;
    }
  }
}
</style>
